var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Inspection2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 4H5.33337V29.3333H26.6667V4Z",
    fill: "#FFDD64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0203 9.29261L26.6633 6.93555L13.048 20.5504L15.405 22.9075L29.0203 9.29261Z",
    fill: "#FF71AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 2H11.3334V6H20.6667V2Z",
    fill: "#3DE8A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 4H11.3334V6H20.6667V4Z",
    fill: "#126C46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 6.93937L26.6633 6.93604L13.048 20.5514L15.4053 22.908L26.6666 11.6467V6.93937Z",
    fill: "#FB348C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.665 14.4538L9.30798 16.8109L15.4052 22.908L17.7622 20.5509L11.665 14.4538Z",
    fill: "#FB348C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Inspection2);
export default __webpack_public_path__ + "static/media/icons8-inspection-2.feff6161735594ac96c14679a923f7dc.svg";
export { ForwardRef as ReactComponent };